import {set as setBadge, clear as clearBadge} from 'badgin';
import store from "store";
import JSbridge from "./JSbridge";
const BADGE_UID_KEY = 'badge-uid';

const whenNotificationPermissionGranted = () => {
    if ('Notification' in window) {
        if (Notification.permission === 'granted') {
            return Promise.resolve();
        }
    }    return Promise.reject(new Error("Browser does not support Notification"))
}

const isPWAMode = () => {
    return !!(window.matchMedia('(display-mode: standalone)').matches);
}

const setAppBadgeAvailable = () => {
    return whenNotificationPermissionGranted().then(() => {
        if (navigator.setAppBadge && isPWAMode()) {
            return Promise.resolve();
        }
        return Promise.reject(new Error('Browser does not support setAppBadge'))
    })
}

export default {

    setBadge(badge = 0) {
        setAppBadgeAvailable()
            .then(() => {
                navigator.setAppBadge(badge);
            })
            .catch(() => {
                setBadge(badge);
            })

        JSbridge.setBadge(badge);

        console.log(`setBadge ${badge}`);
    },

    clear() {
        setAppBadgeAvailable()
            .then(() => {
                navigator.clearAppBadge();
            })
            .catch(() => {
                clearBadge()
            })

        JSbridge.setBadge(0);
        store.set(BADGE_UID_KEY, []);
    },

    add(uid) {
        let list = store.get(BADGE_UID_KEY) || [];
        if(list.includes(uid)) return;
        list.push(uid)
        store.set(BADGE_UID_KEY, list);
        this.setBadge(list.length)
    },

    remove(uid) {
        let list = store.get(BADGE_UID_KEY) || [];
        list = list.filter((row) => {
            return row != uid
        })
        store.set(BADGE_UID_KEY, list);
        this.setBadge(list.length)
        return list.length;
    },

    list() {
        return store.get(BADGE_UID_KEY) || [];
    },

    update(list){
        store.set(BADGE_UID_KEY, list);
        this.setBadge(list.length)
    },
}
export {
    whenNotificationPermissionGranted,
    setAppBadgeAvailable,
}
